module.exports = __webpack_public_path__ + "static/media/9.6c8da799.jpg";